var justifyContentMap = {
    start: "flex-start",
    center: "center",
    end: "flex-end",
    between: "space-between",
    around: "space-around",
    stretch: "stretch",
};
export default (function (_a) {
    var justifyContent = _a.justifyContent;
    return justifyContent in justifyContentMap
        ? "justify-content: " + justifyContentMap[justifyContent] + ";"
        : "";
});
